<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav name="tab-refunds">
                <b-nav-item @click="displayList">
                    <i class="cus-money-refund"></i>
                    Refunds
                </b-nav-item>
            </b-nav>
        </template>
        <b-card-text>
            <refund-list ref="refundList" :key="keyview" />
        </b-card-text>
    </b-tab>
</template>

<script>
import RefundList from "@/components/billing-refunds/refunds-list";

export default {
    components: {
        RefundList
    },
    data() {
        return {
            keyview: 0
        };
    },
    methods: {
        displayList() {
            this.keyview += 1;
        }
    }
};
</script>
